import { render, staticRenderFns } from "./FooterThree.vue?vue&type=template&id=5115b99b&"
import script from "./FooterThree.vue?vue&type=script&lang=js&"
export * from "./FooterThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports